import { css } from '@emotion/core';
import { typographyStyles } from '@newsela/angelou';

const { textS } = typographyStyles;

export const $standardCard = css`
    background-color: white;
    margin-bottom: 6px;
    padding: 8px;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    border: solid 1px #0A6EFA;
    ${textS};
`;

export const $accuracyRating = (isUpperThreshold) => css`
background-color: ${isUpperThreshold ? '#0A6EFA' : '#FEC800'};
border-radius: 12px;
color: white;
padding: 0 8px;
font-size: 12px;
font-weight: 400;
`;

export const $cardBody = (isReviewing) => css`
    padding: ${isReviewing ? '0 8px 0 36px' : '0 8px 0 46px'};
`;

export const $cardHeader = css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-height: 28px;

    div:first-of-type {
        display: flex;
        height: inherit;
        align-items: center;
    }

    span {
    margin: 2px;
    color: #1D1D1D;
    }

    label:first-of-type {
        flex: 0;
        padding: 8px;
        padding-right: 0px;
    }
`;

export const $trashIcon = css`
  width: 24px;
  margin-right: 8px;
  cursor: pointer;
`;
